var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnerexLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "70.000000pt",
    height: "71.000000pt",
    viewBox: "0 0 70.000000 71.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,71.000000) scale(0.100000,-0.100000)",
    fill: "#a4004a",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168 609 l-118 -59 0 -153 0 -153 117 -64 c64 -36 121 -67 125 -68 5 -2 64 27 133 65 l125 68 0 156 0 155 -122 57 c-68 32 -127 57 -133 57 -5 -1 -63 -28 -127 -61z m209 -15 c43 -20 89 -41 102 -46 24 -9 23 -10 -26 -32 -55 -26 -71 -42 -55 -58 7 -7 26 -1 61 21 28 17 53 31 55 31 2 0 2 -28 -1 -62 -4 -53 -9 -67 -34 -90 -46 -44 -99 -33 -99 20 0 17 -4 23 -15 18 -8 -3 -18 2 -23 11 -6 10 -14 13 -22 8 -10 -6 -9 -11 5 -22 15 -10 16 -16 7 -25 -9 -9 -16 -7 -32 7 -18 16 -20 16 -20 2 0 -10 5 -17 10 -17 6 0 10 -9 10 -20 0 -11 5 -21 10 -21 6 -1 22 -3 38 -5 15 -2 44 -6 65 -10 31 -5 45 -2 68 15 15 11 30 21 33 21 3 0 4 -17 2 -37 -3 -37 -7 -40 -97 -89 l-94 -52 -5 57 c-4 41 -9 56 -20 56 -12 0 -15 -13 -15 -58 0 -31 -3 -56 -6 -55 -4 2 -48 26 -98 53 l-91 50 0 123 c0 136 -1 135 67 107 52 -22 74 -44 68 -69 -3 -12 -1 -28 4 -36 9 -12 17 -8 50 24 43 42 44 61 4 53 -17 -3 -32 4 -52 24 -16 15 -41 31 -57 34 -60 14 -58 17 31 60 50 24 91 44 92 44 1 1 37 -15 80 -35z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnerexLogo);
export default __webpack_public_path__ + "static/media/enerexLogo.c71dbaf5e14a1c479a426f4b55b954c7.svg";
export { ForwardRef as ReactComponent };